import { z } from "zod";

export const BACKUP_FORMAT = "vocably-backup";
export const BACKUP_FORMAT_VERSION = 1;
export const PRE_MIGRATION_COPY_FORMAT = "vocably-pre-migration";

export const backupWrapperSchema = z
  .object({
    format: z.literal(BACKUP_FORMAT),
    formatVersion: z.literal(BACKUP_FORMAT_VERSION),
    exportedAt: z.string().min(1),
    snapshot: z.unknown(),
  })
  .strict();

export const preMigrationCopySchema = z
  .object({
    format: z.literal(PRE_MIGRATION_COPY_FORMAT),
    formatVersion: z.literal(1),
    sourceVersion: z.number().int().positive(),
    targetVersion: z.number().int().positive(),
    migratedAt: z.string().min(1),
    originalBytes: z.string().min(1),
  })
  .strict();

export type BackupWrapper = z.infer<typeof backupWrapperSchema>;
export type PreMigrationCopy = z.infer<typeof preMigrationCopySchema>;
